/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/*------------------------------------------------------------------
Requirements
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  // Add the src and a condition required to load the script
  window.ScriptLoader = ScriptLoader({
    './components/scroll': true,
    './components/in-view': document.querySelector('.js-in-view, .js-draw-svg svg, .js-count'),
    './components/parallax': document.querySelector('[data-parallax]'),
    './components/equalizer': document.querySelector('[data-equalize], [data-match-height]'),
    './components/selectors': document.querySelector('select'),
    './components/lazy-load': document.querySelector('[data-src]'),
    './components/breakpoints': document.querySelector('[data-breakpoint]'),
    './components/videos': document.querySelector('.js-video--modal'),
    './components/accordion-grid': document.querySelector('[data-accordion-grid]'),
    './blocks/testimonials': document.querySelector('.js-testimonials'),
    './blocks/accordions': document.querySelector('.js-accordion'),
    './blocks/team': document.querySelector('.js-team'),
    './elements/mega-menu': document.querySelector('.js-mega-menu'),
    './elements/header': true,
    './elements/mobile-menu': true,
    './elements/search': true,
    './elements/search-results': document.querySelector('.js-search-results'),
    './elements/forms': document.querySelector('.js-form form, .js-userform form'),
    './elements/form-steps': document.querySelector('.js-userform')
  });
});

/*------------------------------------------------------------------
ScriptLoader
------------------------------------------------------------------*/

function ScriptLoader() {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // An array of the import object keys
  var scripts = Object.keys(imports);
  // For debugging purposes only
  var components = [];
  var load = function load() {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    // Make sure we have a script to import
    if (i >= scripts.length) {
      // Once everything has loaded, fire a 'scripts-loaded' event 
      setTimeout(function () {
        return window.dispatchEvent(new Event('scripts-loaded'));
      }, 500);
      return;
    }
    ;

    // Increment the index
    i += 1;

    // If this script is not needed, continue to the next script;
    if (!imports[scripts[i]]) {
      load(i);
      return;
    }
    ;

    // Otherwise continue on to load the script
    import("".concat(scripts[i])).then(function () {
      return components.push(scripts[i]);
    })["catch"](function (error) {
      return console.warn(error);
    })["finally"](function () {
      return load(i);
    });
  };
  load();
  return components;
}

/*------------------------------------------------------------------
Add scripts to the Script Loader object below
------------------------------------------------------------------*/